module.exports = __webpack_public_path__ + "static/media/typeBVersion2.59266bdb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hotspots/selfcare/typeBVersion2.png
// module id = 1255
// module chunks = 0